import settings from './enviroment';
import Axios from "axios";

const url = settings.API_URL + 'analytics/products/';
const localUrl = 'http://localhost:3004/api/analytics/products/';

// Función auxiliar para hacer llamados con fallback
const makeRequestWithFallback = async (requestFn, localRequestFn) => {
    try {
        // Intentar primero con la URL de producción
        return await requestFn();
    } catch (error) {
        console.warn('Error con API de producción, intentando con localhost:', error.message);
        try {
            // Si falla, intentar con localhost
            return await localRequestFn();
        } catch (localError) {
            console.error('Error también con localhost:', localError.message);
            throw localError; // Lanzar el error local como último recurso
        }
    }
};

// Función para obtener todos los productos con nombres
export const getAllProductsWithNames = () => {
    const productionRequest = () => Axios.get(url + 'all-with-names');
    const localRequest = () => Axios.get(localUrl + 'all-with-names');
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => {
        console.log('✔️ Datos recibidos de all-with-names:', response.data);
        return response;
    });
    return dataPromise;
}

// Función para obtener todas las competencias asignadas
export const getCompetenceTable = () => {
    const productionRequest = () => Axios.get(url + 'competence-table');
    const localRequest = () => Axios.get(localUrl + 'competence-table');
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { return response });
    return dataPromise;
}

// Función para actualizar un producto (UNIT y QTY)
export const updateProduct = (productoId, unit, qty) => {
    const productionRequest = () => Axios.put(url + `update/${productoId}`, {
        unit: unit,
        qty: qty
    });
    const localRequest = () => Axios.put(localUrl + `update/${productoId}`, {
        unit: unit,
        qty: qty
    });
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { return response });
    return dataPromise;
}

// Función para insertar una competencia para un producto
export const insertCompetence = (productoId, competenceId) => {
    const productionRequest = () => Axios.post(url + `competence/${productoId}`, {
        competenceId: competenceId
    });
    const localRequest = () => Axios.post(localUrl + `competence/${productoId}`, {
        competenceId: competenceId
    });
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { return response });
    return dataPromise;
}

// Función para eliminar una competencia
export const deleteCompetence = (competenciaId) => {
    const productionRequest = () => Axios.delete(url + `competence/${competenciaId}`);
    const localRequest = () => Axios.delete(localUrl + `competence/${competenciaId}`);
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { return response });
    return dataPromise;
}

// Función para actualizar cantidades de competencias en lote
export const bulkUpdateCompetenceQty = (updates) => {
    const productionRequest = () => Axios.put(url + 'bulk-update-qty', {
        updates: updates
    });
    const localRequest = () => Axios.put(localUrl + 'bulk-update-qty', {
        updates: updates
    });
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { return response });
    return dataPromise;
}

// Función para actualizar el estado de competencia de un producto
export const updateProductCompetence = (productoId, competence) => {
    const productionRequest = () => Axios.put(url + `competence/${productoId}`, {
        competence: competence
    });
    const localRequest = () => Axios.put(localUrl + `competence/${productoId}`, {
        competence: competence
    });
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { return response });
    return dataPromise;
}

// Función para obtener el histórico de modificaciones de un producto
export const getProductHistory = (productoId) => {
    console.log('📡 getProductHistory llamado con ID:', productoId);
    console.log('📡 Tipo de ID:', typeof productoId);
    
    // Validar que el ID sea válido
    if (!productoId || isNaN(productoId)) {
        console.error('❌ ID de producto inválido:', productoId);
        return Promise.reject(new Error('ID de producto inválido'));
    }
    
    const productionRequest = () => {
        const fullUrl = url + `history/${productoId}`;
        console.log('🌐 URL de producción:', fullUrl);
        return Axios.get(fullUrl);
    };
    
    const localRequest = () => {
        const fullUrl = localUrl + `history/${productoId}`;
        console.log('🌐 URL local:', fullUrl);
        return Axios.get(fullUrl);
    };
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { 
        console.log('✔️ Historial recibido:', response.data);
        return response;
    }).catch((error) => {
        console.error('❌ Error al obtener historial:', error);
        console.error('❌ Respuesta del servidor:', error.response?.data);
        throw error;
    });
    return dataPromise;
}

// Función para actualizar precios en lote
export const bulkUpdatePrices = (cambios) => {
    const productionRequest = () => Axios.put(url + 'bulk-update-prices', {
        cambios: cambios
    });
    const localRequest = () => Axios.put(localUrl + 'bulk-update-prices', {
        cambios: cambios
    });
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { 
        console.log('✔️ Precios actualizados en lote:', response.data);
        return response;
    });
    return dataPromise;
}

// Función para insertar historial de precios
export const insertPriceHistory = (priceChanges) => {
    const productionRequest = () => Axios.post(url + 'price-history', {
        priceChanges: priceChanges
    });
    const localRequest = () => Axios.post(localUrl + 'price-history', {
        priceChanges: priceChanges
    });
    
    const promise = makeRequestWithFallback(productionRequest, localRequest);
    const dataPromise = promise.then((response) => { 
        console.log('✔️ Historial de precios insertado:', response.data);
        return response;
    });
    return dataPromise;
}
